<template>
  <div class="register absolute" style="color:#000;">
    <div class="register_tit">
      <img @click="fanhui" src="../../assets/images/licai/fanhui.png" />
      <p class="">{{ $t("m.jy_span4") }}</p>
    </div>

    <div class="register_block">
      <div style="border-radius:8px;background:#fff;padding:15px 15px;margin-top:8px;">
        <div v-if="payConfig.wx_pay!=0" style="height:40px;display:flex;align-items:center;" @click="backShow1('wx')">
          <img src="../../assets/images/wxpay.png" style="width:20px;height:20px;margin-right:10px;" alt="" />
          <div style="flex:1">
            <p style="font-size:12px;color:#777;">微信</p>
          </div>
          <img style="width:20px;" :src="xuan=='wx'?img1:img2" />
        </div>

        <div v-if="payConfig.zfb_pay!=0" style="height:40px;display:flex;align-items:center;" @click="backShow1('zfb')">
          <img src="../../assets/images/alpay.png" style="width:20px;height:20px;margin-right:10px;" alt="" />
          <div style="flex:1">
            <p style="font-size:12px;color:#777;">支付宝</p>
          </div>
          <img style="width:20px;" :src="xuan=='zfb'?img1:img2" />
        </div>

        <div v-if="payConfig.wx_pay==0&&payConfig.zfb_pay==0" style="font-size:13px;color:#999;text-align:center;padding:15px 0;">
          暂无可用充值通道
        </div>
      </div>

      <div style="border-radius:8px;background:#fff;padding:0 15px;margin-top:8px;">
        <div style="border-bottom:1px solid #eee;font-size:26px;font-weight:bold;padding-left:0;margin-top:0;line-height:80px;display:flex;align-items:center;">
          <div style="width:60px;font-size:17px;">{{ $t("m.tz_span4") }}</div>
          <div style="flex:1;">
            <input ref="email" type="number" :placeholder="$t('m.ct_span24')" style="margin-left:0;line-height:80px;width:100%;flex:1;font-size:20px;" v-model="money" />
          </div>
          <div style="width:20px;">
            <img @click="gg" src="../../assets/images/licai/guanbi1.png" style="width:20px;height:20px;" alt="" />
          </div>
        </div>

        <div v-if="currentRechargeScope" style="font-size:12px;color:#999;line-height:35px;">
          充值范围：{{ currentRechargeScope }}
        </div>
      </div>

      <div style="border-radius:8px;background:#fff;padding:20px 15px;margin-top:8px;padding-bottom:0;">
        <!-- <div style="font-size:26px;font-weight:bold;padding-left:0;margin-top:0;line-height:40px;display:flex;align-items:center;width:100%;">
          <div style="display:flex;margin-top:0;width:100%;">
            <span style="font-size:14px;font-weight:bold;width:60px;color:#777;">{{ $t("m.jf_span7") }}</span>
            <input style="border-bottom:1px solid #eee;color:#777;font-size:14px;font-weight:bold;flex:1;line-height:40px;" v-model="bz" type="text" :placeholder="$t('m.hz_span5')" />
          </div>
        </div> -->

        <div @click="dianjis" style="border-radius:8px;background:#fff;padding:0;margin-top:0;height:40px;padding-left:0;display:flex;align-items:center;">
          <div style="flex:1">
            <p style="font-size:12px;color:var(--bg-color);">{{ $t("m.ct_span2") }}</p>
          </div>
          <img src="../../assets/images/new/youjiantou.png" style="width:15px;height:15px;" alt="" />
        </div>
      </div>

      <div class="register_submit" :style="payConfig.wx_pay==0&&payConfig.zfb_pay==0?'opacity:.5;':''" @click="registerReset">
        {{ $t("m.ct_span22") }}
      </div>
    </div>

    <div v-if="show" style="background:rgba(0,0,0,.5);position:fixed;width:100%;height:100%;left:0;top:0;">
      <div style="color:#000;position:absolute;bottom:1rem;left:0;width:100%;height:60vh;background:#fff;border-radius:5px 5px 0 0;padding:10px;">
        <img src="../../assets/images/licai/guanbi2.png" @click="guanbi" style="width:20px;height:20px;" alt="" />

        <div style="text-align:center;font-size:15px;margin-top:20px;">充值</div>

        <div style="text-align:center;font-size:11px;padding-bottom:30px;border-bottom:1px solid #eee;">
          ¥ <span style="font-size:40px;">{{ money }}</span>
        </div>

        <div style="display:flex;align-items:center;font-size:15px;height:70px;">
          <span style="width:70px;">付款方式</span>
          <span style="flex:1;flex-direction:row-reverse;display:flex;">
            {{ xuan=="wx"?"微信":xuan=="zfb"?"支付宝":"" }}
          </span>
          <img src="../../assets/images/licai/right.png" style="width:20px;height:20px;margin-left:10px;" alt="" />
        </div>

        <div v-if="currentRechargeScope" style="font-size:12px;color:#999;text-align:center;margin-top:-10px;">
          充值范围：{{ currentRechargeScope }}
        </div>

        <div class="register_submit" style="margin-top:35px;" @click="register_submit">立即付款</div>
      </div>
    </div>

    <van-dialog confirmButtonColor="#ff1900" v-model="passwordShow" :title="$t('m.yh_span7')" show-cancel-button @confirm="pwdChange2" @cancel="pwd=''" @close="pwd=''">
      <div class="zfmm">
        <van-field v-model="pwd" :placeholder="$t('m.ct_span11')" type="password" />
      </div>
    </van-dialog>

    <div v-if="shows" style="background:rgba(0,0,0,.5);position:fixed;width:100%;height:100%;left:0;top:0;display:flex;align-items:center;justify-content:center;">
      <div style="background:rgba(0,0,0,.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;">
        {{ $t("m.tijiaoing") }}
      </div>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
import { getMyUserInfo } from "@api/user";
import $store from "../../store";

export default {
  name:"CzContent",
  data:function(){
    return {
      passwordShow:false,
      xuan:"",
      img1:require("../../assets/images/new/xuanzhong.png"),
      img2:require("../../assets/images/new/weixuanzhong.png"),
      show:false,
      shows:false,
      money:"",
      mima:"",
      dicdata:{},
      list:[],
      bz:"",
      pwd:"",
      bzs:"",
      payConfig:{
        wx_pay:0,
        zfb_pay:0,
        wx_recharge_scope:"",
        zfb_recharge_scope:""
      }
    };
  },
  computed:{
    currentRechargeScope(){
      return this.xuan==="wx"
        ?this.payConfig.wx_recharge_scope
        :this.xuan==="zfb"
          ?this.payConfig.zfb_recharge_scope
          :"";
    }
  },
  mounted:function(){
    if(this.$refs.email){
      this.$refs.email.focus();
    }

    let that=this;

    setTimeout(function(){
      getMyUserInfo().then(res=>{
        let userInfo=res.data.data;

        that.payConfig={
          wx_pay:Number(userInfo.wx_pay||0),
          zfb_pay:Number(userInfo.zfb_pay||0),
          wx_recharge_scope:userInfo.wx_recharge_scope||"",
          zfb_recharge_scope:userInfo.zfb_recharge_scope||""
        };

        if(that.payConfig.wx_pay!=0){
          that.xuan="wx";
        }else if(that.payConfig.zfb_pay!=0){
          that.xuan="zfb";
        }

        if(userInfo.is_auth!=1){
          that.$router.push({
            name:"memmber_business"
          });
        }
      });
    },500);

    request.get("/pay/bank/list",{page:1},{login:true})
      .then(res=>{
        this.list=res.data.data||[];

        for(let i=0;i<this.list.length;i++){
          const dd=this.list[i].card;

          if(dd){
            this.list[i].card=dd.substr(dd.length-4,4);
          }

          if(i==0){
            this.bzs=this.list[i].card;
          }
        }
      })
      .catch(err=>{
        if(err.response&&err.response.data){
          this.$dialog.error(err.response.data.msg);
        }
      });
  },
  methods:{
    pwdChange2(){
      let vm=this;

      if(!this.xuan){
        this.$dialog.error("请选择充值方式");
        return;
      }

      let payCode=this.xuan==="wx"
        ?this.payConfig.wx_pay
        :this.payConfig.zfb_pay;

      if(!payCode||Number(payCode)<=0){
        this.$dialog.error("当前充值通道不可用");
        return;
      }

      vm.passwordShow=false;
      vm.shows=true;

      let dic={
        money:this.money,
        remark:this.bz,
        pay_type:this.xuan,
        pay_code:payCode
      };

      request.post("/pay/pay/recharge",dic,{login:true})
        .then(res=>{
          vm.shows=false;

          let result=res&&res.data?res.data:{};
          let data=result.data||{};

          if(data.payJumpUrl){
            window.location.href=data.payJumpUrl;
            return;
          }

          if(data.payMethod==="formJump"&&data.payUrl){
            document.open();
            document.write(data.payUrl);
            document.close();
            return;
          }

          if(data.codeUrl){
            vm.show=false;
            vm.$dialog.alert({
              title:"请扫码支付",
              message:data.codeUrl
            });
            return;
          }

          if(data.codeImgUrl){
            vm.show=false;
            vm.$dialog.alert({
              title:"请扫码支付",
              message:"请使用微信或支付宝扫码完成支付"
            });
            return;
          }

          vm.$dialog.error(result.msg||"未获取到支付地址");
        })
        .catch(err=>{
          vm.shows=false;

          if(err.response&&err.response.data){
            vm.$dialog.error(
              err.response.data.msg||
              err.response.data.message||
              "支付订单创建失败"
            );
          }else{
            vm.$dialog.error("提交失败，请稍后重试");
          }
        });
    },

    backShow1(E){
      this.xuan=E;
    },

    fanhui(){
      this.$router.push({
        path:"/"
      });
    },

    gg(){
      this.money="";
    },

    guanbi(){
      this.show=false;
    },

    dianjis(){
      let view=$store.state.app.view;

      if(view=="local"){
        this.$router.push({
          path:"/mychat"
        });
      }else{
        this.$router.push({
          path:"/customerService"
        });
      }
    },

    register_submit(){
      if(!this.money||Number(this.money)<=0){
        this.$dialog.message("请输入付款金额");
        return;
      }

      if(!this.xuan){
        this.$dialog.message("请选择充值方式");
        return;
      }

      let payCode=this.xuan==="wx"
        ?this.payConfig.wx_pay
        :this.payConfig.zfb_pay;

      if(!payCode||Number(payCode)<=0){
        this.$dialog.message("当前充值通道不可用");
        return;
      }

      let scope=this.currentRechargeScope;

      if(scope){
        let match=scope.match(/^\s*(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)\s*$/);

        if(match){
          let min=Number(match[1]);
          let max=Number(match[2]);
          let amount=Number(this.money);

          if(amount<min||amount>max){
            this.$dialog.message("充值金额范围："+min+"-"+max);
            return;
          }
        }
      }

      this.pwdChange2();
    },

    registerReset(){
      if(this.payConfig.wx_pay==0&&this.payConfig.zfb_pay==0){
        this.$dialog.message("暂无可用充值通道");
        return;
      }

      if(!this.money||Number(this.money)<=0){
        this.$dialog.message("请输入付款金额");
        return;
      }

      if(!this.xuan){
        this.$dialog.message("请选择充值方式");
        return;
      }

      let payCode=this.xuan==="wx"
        ?this.payConfig.wx_pay
        :this.payConfig.zfb_pay;

      if(!payCode||Number(payCode)<=0){
        this.$dialog.message("当前充值通道不可用");
        return;
      }

      let scope=this.currentRechargeScope;

      if(scope){
        let match=scope.match(/^\s*(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)\s*$/);

        if(match){
          let min=Number(match[1]);
          let max=Number(match[2]);
          let amount=Number(this.money);

          if(amount<min||amount>max){
            this.$dialog.message("充值金额范围："+min+"-"+max);
            return;
          }
        }
      }

      this.pwdChange2();
    }
  }
};
</script>



<style scoped lang="less">
/deep/.zfmm {
  padding: 10px;
  padding-bottom: 20px;
  width: 100%;
  text-align: center;
  color: #333333;
  padding-left: 20px;
  padding-right: 20px;

  .van-field {
    background-color: #f1f1f3;
    background-color: #f1f1f3;
  }
}
/deep/ .van-key--blue {
  background: var(--bg-color);
}
.register_submit {
  margin: 0 auto;
  height: 50px;
  background: var(--bg-color);
  border-radius: 5px;
  margin-top: 25px;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  font-size: 16px;
  border-radius: 30px;
}

.register_block {
  padding: 10px;
}
.register_block_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 15px;
}
.register_code_lists {
  border: 1px solid #ff1900;
  text-align: center;
  color: #ff1900;
  border-radius: 6px;
  width: 36%;
  height: 45px;
  margin-left: 15px;
  line-height: 45px;
}
.register_code_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.register_code {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.register_tit {
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
</style>
